import { Typography } from '@mui/material'
import React from 'react'

function SectionTitle({ title }: { title: string }) {
  return (
    <Typography
      sx={{
        fontSize: '18px',
        paddingBottom: '12px',
        paddingTop: '8px',
        fontWeight: 600,
      }}
    >
      {title}
    </Typography>
  )
}

export default SectionTitle
